module.exports = __webpack_public_path__ + "img/2.dfa50770.png";